export default {
  close: "mdi-close",
  save: "mdi-content-save",
  add: "mdi-plus-circle-outline",
  arrowLeft: "mdi-arrow-left",
  arrowRight: "mdi-arrow-right",
  trash: "mdi-trash-can",
  maximize: "mdi-window-maximize",
  minimize: "mdi-window-minimize",
  menu_down: "mdi-menu-down",
  menu_right: "mdi-menu-right",
  arrow_down: "mdi-arrow-down",
  arrow_up: "mdi-arrow-up",
  mdi_cog_transfer: "mdi-cog-transfer",
  logout: "mdi-logout-variant",
  arrowBoldLeft: "mdi-arrow-left-bold-circle",
  arrowBoldRight: "mdi-arrow-right-bold-circle",
};
